import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGalleryClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    } else {
      document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer style={{ background: '#090C12' }} className="border-t border-white/5">
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-5 cursor-pointer">
              <img
                src="https://storage.readdy-site.link/project_files/be4287be-1b15-4a9d-9900-25ef163f62d9/9b6be2bb-b0b7-4a08-9842-7d666baf6ae2_hamva-logo--1.png?v=f2299e6ba6265339a88c77116d80f6d6"
                alt="Hamva Pharmaceuticals"
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="text-text-muted text-sm leading-relaxed max-w-xs mb-6">
              Hamva Pharmaceuticals delivers high-performance veterinary solutions trusted by farmers and distributors across Pakistan.
            </p>
            <p className="text-xs text-white/30 mb-1">Manufactured by</p>
            <p className="text-sm text-text-soft font-medium">Metsun Pharma &mdash; 8km Lahore GT Road Rawat Rawalpindi</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold font-poppins text-sm uppercase tracking-wider mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', to: '/' },
                { label: 'Products', to: '/products' },
                { label: 'About Us', to: '/about' },
                { label: 'Gallery', to: null },
                { label: 'Contact', to: '/contact' },
              ].map((item) =>
                item.to ? (
                  <li key={item.label}>
                    <Link
                      to={item.to}
                      className="text-text-muted hover:text-accent text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </Link>
                  </li>
                ) : (
                  <li key={item.label}>
                    <button
                      onClick={handleGalleryClick}
                      className="text-text-muted hover:text-accent text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </button>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Get in Touch */}
          <div>
            <h4 className="text-white font-semibold font-poppins text-sm uppercase tracking-wider mb-6">
              Get in Touch
            </h4>
            <div className="space-y-4">
              <a
                href="https://wa.me/923007321011"
                target="_blank"
                rel="noopener noreferrer"
                className="wa-btn flex items-center gap-3 px-5 py-3 rounded-full text-sm font-semibold text-white cursor-pointer whitespace-nowrap w-fit"
              >
                <i className="ri-whatsapp-line text-lg" />
                WhatsApp Us
              </a>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-accent" />
                </div>
                <div>
                  <p className="text-xs text-white/40 mb-0.5">Phone</p>
                  <a href="tel:+923007321011" className="text-text-soft text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                    +92 300 7321011
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-accent" />
                </div>
                <div>
                  <p className="text-xs text-white/40 mb-0.5">Manufacturing</p>
                  <p className="text-text-soft text-sm">Metsun Pharma, 8km Lahore GT Road Rawat Rawalpindi</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs text-center sm:text-left">
            &copy; 2024 Hamva Pharmaceuticals. All rights reserved.
          </p>
          <p className="text-white/20 text-xs">
            Manufactured by <span className="text-white/40">Metsun Pharma, 8km Lahore GT Road Rawat Rawalpindi</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
